module.exports = __webpack_public_path__ + "static/media/pes.72bc48e3.png";